<template>
    <div class="mb-5"> 
        <h5 class="card-title">Community Insights</h5>
        <div class="row">
             <a class="col-md-6 mb-3 mb-md-4" v-for="insight in displayInsights" :key="insight.id" v-router-link="{ name: 'InsightDetail', params: { id: insight.insight.id }}">
                <div class="card" >
                    <h3>{{ insight.insight.title | truncate(50, '...')  }}</h3>
                    <!-- TODO: summary field is missing in db -->
                    <!-- <p>{{ insight.insight.summary | truncate(70, '...')  }}</p> -->
                    <small class="author">{{ insight.insight.author.name }}</small>
                    <small class="metadata">{{ insight.insight.publishedAt | moment('MMM d')}} - {{insight.insight.duration}}</small>
                </div>
            </a>
        </div>
        <see-more-button 
            v-if="insights.length > 2" 
            :count="insights.length - 2"
            @showMore="(status) => showMore = status"
        ></see-more-button>
    </div>
</template>

<script>
import SeeMoreButton from  '../global/SeeMoreButton';

export default {
    name: 'network-insights-card',

    components: {
        SeeMoreButton,
    },

    props: {
        insights: {
            type: Array,
            default: []
        }
    },

    data() {
        return {
            showMore: false,
        }
    },

    computed: {
        displayInsights() {
            return (this.showMore) ? this.insights : this.insights.slice(0, 2);
        }
    }
}
</script>

<style lang="scss" scoped>
    .card {
        padding: 20px;
        height: 100%;
    }

    p {
        font-size: 15px;
        color: #505B64;
    }

    h3 {
        font-weight: 700;
    }

    small {
        font-size: 14px;
        color: #505B64;

        &.metadata {
            color: $grey-text;
        }
    }
</style>
